window.LazyLoad = require('vanilla-lazyload');

window.onload = function () {
  //lazy loading for images
  window.LazyLoad = new LazyLoad({
    elements_selector: "img",
    // When the .lazy div enters the viewport...
    callback_enter: function(el) {
      if (screen.width > 1200) {
        //set sticky sidebar ads height
        setTimeout(function () {
          //parent container overflow modifications
          document.querySelector('main').style.overflow = "visible";
          //left content site height
          var leftSideHeight  = document.querySelector('main').clientHeight;
          //select stickies
          var stickyDivs      = document.querySelectorAll(".sticky_sidebar_ad_container");
          //select stickies
          var stickyDivsCount = stickyDivs.length;
          //calculate needed height for each sticky
          var stickyDivHeight = ((leftSideHeight - stickyDivsCount * 50) / stickyDivsCount).toFixed(0);
          //applying height to stickies
          for (var i = 0; i < stickyDivsCount; i++) {
            stickyDivs[i].style.height = stickyDivHeight + "px";
          }	//the event occurred
        }, 50);
      }
    }
  });
};
